/**
 * DraftPreviewSection — inline preview of a selected draft report with approve/rerun actions.
 * Stage 3 UI extraction from ReportsPage.js
 */
import React from 'react';
import { Button } from '../ui/button';
import { Save, X } from 'lucide-react';
import { toast } from 'sonner';
import api from '../../services/api';
import DailySaleUpdateDocument from './DailySaleUpdateDocument';

const DraftPreviewSection = ({ previewDraft, onClose, visibleCols, fetchSavedReports, navigate, setPreviewDraft }) => {
  if (!previewDraft) return null;

  const handleRerun = async () => {
    try {
      const res = await api.post(`/reports/saved/${previewDraft.id}/rerun`);
      setPreviewDraft(res.data);
      toast.success('Report updated with latest data');
      fetchSavedReports();
    } catch {
      toast.error('Failed to rerun report');
    }
  };

  const handleApprove = async () => {
    try {
      await api.post('/dsu-automation/bulk-approve', { report_ids: [previewDraft.id] });
      toast.success('Report approved');
      onClose();
      fetchSavedReports();
      navigate(`/reports/saved/${previewDraft.id}`);
    } catch {
      toast.error('Failed to approve');
    }
  };

  return (
    <div className="space-y-3">
      <div className="flex items-center justify-between flex-wrap gap-2">
        <div className="flex items-center gap-2">
          <Button variant="ghost" size="sm" onClick={onClose}>
            <X className="w-4 h-4 mr-1" /> Close Draft
          </Button>
          <span className="text-sm text-muted-foreground">{previewDraft.report_name} — {previewDraft.crm_entity_name}</span>
        </div>
        <div className="flex gap-2">
          <Button variant="outline" size="sm" onClick={handleRerun}>Rerun Report</Button>
          <Button className="bg-primary hover:bg-primary/90 text-white" onClick={handleApprove}>
            <Save className="w-4 h-4 mr-1" /> Approve Report
          </Button>
        </div>
      </div>
      <DailySaleUpdateDocument
        data={previewDraft.report_data}
        columns={visibleCols.length > 0 ? visibleCols : (previewDraft.columns || [])}
      />
    </div>
  );
};

export default DraftPreviewSection;
